/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback, useState } from 'react'
import { learningApi } from '../../services/api'

import {
  WrapperContainer,
  Modal,
  Wrapper,
  CardsAnnotations,
  CardMark,
  CardNote,
  NoteAndDelete,
  ButtonsSendCancel,
  ChangeColor,
} from './styles'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/modules/rootReducer'
import SeeNote from '../SeeNoteModal'
import SendDoubt from '../SendDoubt'
import { toast } from 'react-toastify'

import { MdDelete, MdClose, MdOutlineFormatColorFill } from 'react-icons/md'
import { BiLeftArrowAlt } from 'react-icons/bi'
import ModalConfirmation from '../ModalConfirmation'
import ContentLoader from 'react-content-loader'
import ModalEmpty from '../ModalEmpty'
import { useMount } from 'react-use'
import { createModalPortal } from 'utils/createModalPortal'

interface TitleProps {
  close(): void
  name: any
  typeModal: 'marks' | 'notes'
  lessonId: string
  moduleId: string
  chapterId: string
  courseId: string
  objectId: string
  setColor: any
  isFreemium: boolean
  annotations: any[]
  setOpenModalFreemium(boolean): void
  refetchAnnotations(): void
  loadingAnotation: boolean
}

const ModalAnnotation: React.FC<TitleProps> = ({
  close,
  name,
  typeModal,
  lessonId,
  moduleId,
  chapterId,
  courseId,
  objectId,
  setColor,
  isFreemium,
  setOpenModalFreemium,
  annotations,
  loadingAnotation,
  refetchAnnotations,
}) => {
  const token = localStorage.getItem('token')
  const { isDarkMode } = useSelector((state: RootState) => state.theme)
  const [item, setItem] = useState<any | undefined>()
  const [step, setStep] = useState<number | string>(0)
  const [annotationId, setAnnotationId] = useState<string>('')
  const [openSendDoubt, setOpenSendDoubt] = useState<boolean>(false)
  const [openColorPicker, setOpenColorPicker] = useState<boolean>(false)
  const [cardSelect, setCardSelect] = useState<number>(undefined)
  const [idNote, setIdNote] = useState<string>('')
  const [textNote, setTextNote] = useState<string>('')
  const [openSendNote, setOpenSendNote] = useState<boolean>(false)
  const [textOfNote, setTextOfNote] = useState<string>('')
  const [itemToDelete, setItemToDelete] = useState<any>({})
  const [openModal, setOpenModal] = useState<boolean>(false)

  const handleOpenColorPicker = () => {
    setOpenColorPicker(false)
    setCardSelect(undefined)
  }

  const handleSelectColor = ({ _id: id }, key) => {
    setIdNote(id)
    setCardSelect(key)
    setOpenColorPicker(true)
  }

  const handleSetColor = ({ id, color }) => {
    setColor({ id, color })
    if (cardSelect !== undefined) {
      const card = document.getElementById(cardSelect.toString())
      const className = card.className
      card.className = className.replace(className[className.length - 1], color[color.length - 1])
    }
    setCardSelect(undefined)
    setOpenColorPicker(false)
  }

  const colorPicker = ['highlight-1', 'highlight-2', 'highlight-3', 'highlight-4']
  const handleCloseModal = (e) => {
    if (e.target?.id === 'modal') closeModal()
  }

  const closeModal = useCallback(() => {
    close()
  }, [close])

  const handleDeleteNote = async (item) => {
    setItemToDelete(item)
    setOpenModal(true)
  }

  const handleCloseModalConfirmation = async () => {
    setOpenModal(false)
  }

  const DeleteNote = useCallback(async () => {
    await learningApi.delete(`/annotation/${itemToDelete?._id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    toast.success('Item excluído com sucesso')

    refetchAnnotations()
  }, [itemToDelete?._id, token, refetchAnnotations])

  const handleItem = useCallback((itm) => {
    setItem(itm)
    setStep(1)
  }, [])

  const handleSetStep = useCallback((stepNumber: number) => setStep(stepNumber), [])

  const handleSetTextNote = (value) => {
    setTextNote(value)
  }

  const handleSelectNote = ({ _id: id, note, text }) => {
    setTextNote(note)
    setAnnotationId(id)
    setTextOfNote(text)
    setOpenSendNote(true)
  }

  const handleSetAnnotation = useCallback((id) => {
    setAnnotationId(id)
    setOpenSendDoubt(true)
  }, [])

  const LoaderProps = {
    speed: 2,
    backgroundColor: isDarkMode ? '#222222' : '#bababa',
    foregroundColor: isDarkMode ? '#2b2b2b' : '#dedede',
  }

  useMount(() => refetchAnnotations())

  return createModalPortal(
    <>
      {annotations?.length > 0 ? (
        <WrapperContainer id="modal" onClick={handleCloseModal}>
          {step === 0 && (
            <Modal>
              <Wrapper>
                <div>
                  <h1>{typeModal === 'marks' ? 'Marcações' : 'Anotações'} deste capítulo</h1>
                  <h2>Capítulo {name}</h2>
                </div>
                <button id="fechar" onClick={closeModal}>
                  <MdClose id="close" size={20} />
                </button>
              </Wrapper>
              <hr />
              {loadingAnotation ? (
                <ContentLoader
                  width={'95%'}
                  height={500}
                  viewBox={'0 0 100% 100%'}
                  {...LoaderProps}
                >
                  <rect x="50" y="20" rx="15" ry="15" width="90%" height="400" />
                </ContentLoader>
              ) : (
                <CardsAnnotations>
                  {annotations.map((item, id) =>
                    item.length !== 0 && item?.highlight ? (
                      <CardMark key={id} className={item?.highlight?.color}>
                        <NoteAndDelete>
                          <p>{item?.highlight?.text}</p>
                        </NoteAndDelete>
                        <div>
                          {item.note ? (
                            <button className="seeNote" onClick={() => handleItem(item)}>
                              Ver anotação
                            </button>
                          ) : (
                            <button onClick={() => handleSetAnnotation(item?._id)}>
                              Criar anotação
                            </button>
                          )}
                          <button onClick={() => handleDeleteNote(item)}>
                            <MdDelete size={20} />
                          </button>
                        </div>
                      </CardMark>
                    ) : (
                      <CardNote key={id} className={item?.color} id={id.toString()}>
                        <NoteAndDelete>
                          <p>{item?.text}</p>
                          <button className="delete" onClick={() => handleDeleteNote(item)}>
                            <MdDelete size={20} />
                          </button>
                        </NoteAndDelete>
                        <div>
                          <button className="seeNote" onClick={() => handleSelectNote(item)}>
                            Ver anotação
                          </button>
                          {openColorPicker && cardSelect === id && (
                            <ChangeColor>
                              <button onClick={() => handleOpenColorPicker()}>
                                <BiLeftArrowAlt size="24" />
                              </button>
                              {colorPicker.map((color, key) => (
                                <button
                                  key={key}
                                  onClick={() => handleSetColor({ id: idNote, color })}
                                >
                                  <span className={color}></span>
                                </button>
                              ))}
                            </ChangeColor>
                          )}
                          {cardSelect !== id && (
                            <>
                              <button
                                className="change-color"
                                onClick={() => handleSelectColor(item, id)}
                              >
                                <MdOutlineFormatColorFill size={20} />
                              </button>
                            </>
                          )}
                        </div>
                      </CardNote>
                    )
                  )}
                </CardsAnnotations>
              )}
              <hr />
              <ButtonsSendCancel>
                <button type="submit" className="back-button" id="modal">
                  Voltar
                </button>
              </ButtonsSendCancel>
            </Modal>
          )}
          {step === 1 && <SeeNote name={name} item={item} setStep={handleSetStep} />}
        </WrapperContainer>
      ) : (
        <ModalEmpty typeModal={typeModal} close={close} />
      )}

      {openSendDoubt && (
        <SendDoubt
          type="annotation"
          title="Anotar"
          text="Enviar uma anotação"
          close={() => setOpenSendDoubt(false)}
          refetchAnnotations={refetchAnnotations}
          courseId={courseId}
          moduleId={moduleId}
          lessonId={lessonId}
          chapterId={chapterId}
          videoId={objectId}
          isText={true}
          annotationId={annotationId}
          isFreemium={isFreemium}
          setOpenModalFreemium={setOpenModalFreemium}
        />
      )}
      {openSendNote && (
        <SendDoubt
          type="annotation"
          title={'Anotações deste Capítulo'}
          text={textOfNote}
          close={() => setOpenSendNote(false)}
          refetchAnnotations={refetchAnnotations}
          courseId={courseId}
          moduleId={moduleId}
          lessonId={lessonId}
          chapterId={chapterId}
          videoId={objectId}
          textNote={textNote}
          handleSetTextNote={handleSetTextNote}
          isText={true}
          annotationId={annotationId}
          isFreemium={isFreemium}
          setOpenModalFreemium={setOpenModalFreemium}
        />
      )}
      <ModalConfirmation
        open={openModal}
        setAnswer={DeleteNote}
        handleCloseModal={handleCloseModalConfirmation}
      />
    </>
  )
}

export default ModalAnnotation
